import { ThemeOptions } from '@mui/material/styles';

export const darkBaseThemeOptions: ThemeOptions = {
  shape: {
    drawerRadius: '0.25rem',
    buttonRadius: {
      large: '0.25rem',
      medium: '0.25rem',
      small: '0.25rem',
      extraSmall: '0.25rem',
    },
    buttonHeight: {
      large: '2.75rem',
      medium: '2.5rem',
      small: '2.25rem',
      extraSmall: '2rem',
    },
    cardRadius: '0.25rem',
    inputRadius: {
      medium: '0.25rem',
      small: '2px',
    },
    inputHeight: {
      medium: '2.5rem',
      small: '2rem',
    },
    modalRadius: '0.25rem',
    menuRadius: '0.25rem',
    menuAnchorRadius: '2px',
    tagRadius: '2px',
    toastRadius: '0.25rem',
    tooltipRadius: '0.25rem',
    tooltipArrowRadius: '0',
    avatarRadius: '0.25rem',
    containerRadius: '0.25rem',
    chipRadius: '0.25rem',
    mapPinRadius: '999px',
  },
};
